import { Burger } from '../core'

export default {
  burger: undefined,
  top: 0,

  init() {
    /* Burger */
    let obj = this
    obj.burger = new Burger('.burger', {
      onToggle: function() {
        var scrollTop = ($('html').scrollTop()) ? $('html').scrollTop() : $('body').scrollTop(); // Works for Chrome, Firefox, IE...
        if (scrollTop != 0) {
          obj.top = scrollTop
        }
        $('body').css('--top',-scrollTop + 'px');
        if (obj.burger.isExpanded) {
          $('body').addClass('--menu-open --no-scroll')
        } else {
          $('body').removeClass('--menu-open --no-scroll')
        }
        window.scrollTo({ top: obj.top});
      },
    })

    /* Submenu parent */
    $('.top-bar .main-menu > li.main-menu__item--parent, .quick-links > li.quick-links__item--parent').each(function() {
      $(this).SubMenuParent({
        mobile: false,
      })
    })

    $('.header__search-btn').click(function() {
      $('.header__search').css('--search-width', $('.header__search .searchform').width() + 'px')
      if (!$('.header__search').hasClass('--search-open')) {
        $('.header__search').addClass('--search-open')
        $('.header__search').find('input[type=text]').focus()
      } else {
        $('.header__search').removeClass('--search-open')
      }
    });

    $('.header__search__submit').click(function() {
      $('.header__search input[type="submit"]').click();
    });

    $(window).click(function() {
      if ($('body').hasClass('--menu-open')) {
        $('body').removeClass('--menu-open --no-scroll')
        $('.header__search').removeClass('--search-open')
        $('.header__burger').attr('aria-expanded', 'false');
        window.scrollTo({ top: obj.top});
        $('main .page-section').first().click();
      }
    });

    $('.navigation__wrapper, .header__burger, .header__search, .header__search-btn').click(function(event){
      event.stopPropagation();
    });

    /* Calculate header height */
    $(window).on('resize load orientationchange', header)
    header()

    /* Language display */
    $.mlmi.mobile.add(function() {
      $('.wpml-ls-native[lang="en"]').text('English')
      $('.wpml-ls-native[lang="fr"]').text('Français')
    }, function() {
      $('.wpml-ls-native[lang="en"]').text('EN')
      $('.wpml-ls-native[lang="fr"]').text('FR')
    })

    let old_current_pos = $(window).scrollTop()
    checkScrollingPosition();

    //Minimize header on scroll down
    $( window ).scroll(function() {
      checkScrollingPosition()
    });

    $(window).on('resize load orientationchange', function() {
      if (!$.mlmi.mobile.isMobile) {
        $('.header').css('--top-bar-height', null);
        $('.header').css('--top-bar-height', $('.header .top-bar').height() + 'px');
      }
    })

    function checkScrollingPosition() {
      var current_pos = $(window).scrollTop()
      if (current_pos < 150) {
        $('.header').removeClass('header--scrolling')
      } else if (old_current_pos < current_pos) {
        $('.header').addClass('header--scrolling')
        $('.mode-inspiration__filters__wrapper .select--opened').removeClass('select--opened')
      } else {
        $('.header').removeClass('header--scrolling')
      }
      old_current_pos = $(window).scrollTop()
    }
  }
}
